import { User } from 'domain/User';
import { Map } from 'immutable';
import DomainObjectView from 'domain/DomainObjectView';
import { AppState } from '../types';

export const getUserById = (state: AppState, id: number): User => {
  if (state.userList.isLoading) {
    throw Error('User list is loading');
  }
  return state.userList.userMapById.get(id) as User;
};

let oldUserMapById: Map<number, DomainObjectView<User>>| null = null;
let userListForOldUserMapById: User[] | null = null;

export const getUserList = (state: AppState): User[] => {
  if (state.userList.isLoading) {
    return [];
  }
  if (oldUserMapById === state.userList.userMapById && userListForOldUserMapById !== null) {
    return userListForOldUserMapById;
  }

  const out = state.userList.userMapById.keySeq().map((key) => getUserById(state, key))
    .sortBy((user) => user.email).toList();

  oldUserMapById = state.userList.userMapById;
  userListForOldUserMapById = out.toArray();
  return userListForOldUserMapById;
};
